import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer1 from "../../components/Footer/Footer1";
import UserSidebar from "../../components/UserProfile/UserSidebar";
import AccountSettings from "../../components/UserProfile/AccountSettings";
import "./UserProfile.css";
import ChangePassword from "../../components/UserProfile/ChangePassword";
import YourOrders from "../../components/UserProfile/YourOrders";
import UserAddress from "../../components/UserProfile/UserAddress";
import LegalNotice from "../../components/UserProfile/LegalNotice";
import Loader from "../../components/Loader/Loader"; // Assurez-vous d'importer votre composant Loader
import Message from "../../components/UserProfile/Message";



const UserProfile = () => {
  const { activepage } = useParams();
  

  // alert(activepage)
  return (
    <div className="userprofile">
      {/* UserProfile , showing {activepage}
       */}
      <div className="userprofilein">
        <div className="left">
          <UserSidebar activepage={activepage} />
        </div>
        <div className="right">
          {activepage === "accountsettings" && <AccountSettings /> }
          {activepage === "changepassword" && <ChangePassword />}
          {activepage === "yourorders" && <YourOrders />}
          {activepage === "address" && <UserAddress />}
          {activepage === "message" && <Message />}
          {/* {activepage === "legalnotice" && <LegalNotice />} */}
        </div>
      </div>
      {/* <Footer1 /> */}
      <br/>
      <div></div>
    </div>
  );
};

export default UserProfile;
